module.exports = __webpack_public_path__ + "7d4d058a4dd72a96981467fb69dab4f8.svg";